export default "__VITE_ASSET__N_dYp4zq__"